import { action, observable } from 'mobx';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SessionShowView } from '../../../../types/sessions';
import { SessionId } from '../../../../../commonv3/types/sessions';
import { SessionApis } from '../../../../apis/sessions';
import { SessionReservationApis } from '../../../../apis/sessionReservations';
import { GlobalStatesV3 } from '../../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../../routes';
import { translateErrorMessage } from '../../../../../commonv3/api/protocol';

export class SessionReservationCompletePaneState {
    @observable sessionId: SessionId = null;
    @observable session: RemoteResourceV3<SessionShowView> = RemoteResourceV3.loading();
    @observable submitting: boolean = false;

    @action.bound
    async init(sessionId: SessionId): Promise<void> {
        this.sessionId = sessionId;
        this.reloadSession();
    }

    @action.bound
    async reloadSession() {
        await updateRemoteResourceV3(this.session, (v) => (this.session = v), () => SessionApis.show(this.sessionId));
    }
}
